import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'
import importFont from '../../static/font/importFont.css'
import {API_BASE_URL, CDB_JWT_ACCESS_TOKEN, ERROR, SUCCESS} from '../common/constants'
import axios from 'axios'
import {API_AUTH} from '../common/api.constants'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    header: {
      titlePage: null,
      dataFilter: null,
      dataFilterByTypeDate: null
    },
    rules: {
      CheckChangeTeam: false
    },
    dashboard: {
      editing: false
    },
    projects: {
      adding: false,
      editing: 0,
      staffNames: [],
      listHeaders: null,
      meetings: null,
      attribute: null,
      appointmentChannelSelect: null,
      industrySelect: null,
      staffSelect: null,
      measureSelect: null,
      clientSelect: null
    },
    account_type: null,
    auth_status: null,
    appointmentProgressData: null,
    appointmentCostProgressData: null,
    loadingYomi: false
  },
  modules,
  actions: {
    getUser ({commit}) {
      return new Promise((resolve, reject) => {
        axios({
          url: API_BASE_URL + API_AUTH,
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'CDB-Access-Token': sessionStorage.getItem(CDB_JWT_ACCESS_TOKEN)
          }
        })
          .then(resp => {
            commit('auth_success', {account_type: resp.data[0].account_type, user: resp.data})
            resolve(resp)
          })
          .catch(err => {
            commit('auth_error')
            reject(err)
          })
      })
    }
  },
  mutations: {
    auth_success (state, payload) {
      state.auth_status = SUCCESS
      state.user = payload.user
      state.account_type = payload.account_type
    },
    auth_error (state) {
      state.auth_status = ERROR
    }
  },
  importFont
})



// WEBPACK FOOTER //
// ./src/store/index.js